import type { Writable } from 'svelte/store';
import { setContext, getContext } from 'svelte';
import type { Logger } from '@bayer-int/portletce-shared';

import type { RootService } from 'portlet/config/service';
import type { AppStore, AppStoreInterface } from 'portlet/store';
import type { Open, Close } from 'portlet/common/components/portletMenu/types';

export const setStoreContext = (store: AppStore): AppStore => setContext('store', store);
export const getStoreContext = (): AppStore => getContext('store');

export const setStoreInterfaceContext = (storeInterface: AppStoreInterface): AppStoreInterface =>
    setContext('store-interface', storeInterface);
export const getStoreInterfaceContext = (): AppStoreInterface => getContext('store-interface');

/**
 * We have to store logger wrapped in Writable, since logger can be configured dynamically.
 * This happends during initialization - when Portlet.wc.svelte first executes, html attributes
 * are not yet parsed, therefore we have to wait until onMount. However context can be only set
 * during component initialization.
 */
export const setLoggerContext = (logger: Writable<Logger>): Writable<Logger> =>
    setContext('logger', logger);
export const getLoggerContext = (): Writable<Logger> => getContext('logger');

/**
 * We have to store service wrapped in Writable, since service can be configured dynamically.
 */
export const setServiceContext = (service: Writable<RootService>): Writable<RootService> =>
    setContext('service', service);
export const getServiceContext = (): Writable<RootService> => getContext('service');

export const setModalContext = (ctx: { open: Open; close: Close }): { open: Open; close: Close } =>
    setContext('modal', ctx);
export const getModalContext = (): { open: Open; close: Close } => getContext('modal');
